import React, { useState } from 'react';
import { Collapse, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
import logo from '../images/logo_sm.jpg';

export function NavMenu(props: { isAuthenticated?: any; } ){
  let displayName = NavMenu.name;

  const [collapsed, setCollapsed] = useState(true);
  
  const toggleNavbar = () => {
    setCollapsed(!collapsed);
  }

  return (
    <header className='site-primary-color-bg'>
      <Navbar className="navbar-expand-sm navbar-toggleable-sm box-shadow" container light>
        <NavbarBrand tag={Link} to="/" className='d-flex flex-row w-25'>
          <img className="w-100" src={logo} />
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="mr-2" />
        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!collapsed} navbar>
          <ul className="navbar-nav flex-grow">
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/">Home</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/services">Services</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/request-quote">Request Quote</NavLink>
            </NavItem>
            <NavItem>
              <NavLink tag={Link} className="text-light" to="/track-shipment">Track Shipment</NavLink>
            </NavItem>
            <LoginMenu isAuthenticated={props.isAuthenticated} />
          </ul>
        </Collapse>
      </Navbar>
    </header>
  );
}
